import { FC } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';
import dayjs from 'dayjs';
import { IExposureHoursMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: IExposureHoursMetric | null;
  period?: string;
  height?: number;
}

export const ExposureHoursChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.months || data.months.length === 0) {
    return <ChartEmptyState />;
  }

  return (
    <ResponsiveContainer width="100%" height={height ?? 220}>
      <BarChart data={data.months} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="month" tickFormatter={(v) => dayjs(v).format('MMM YY')} tick={chartAxisTick} />
        <YAxis yAxisId="hours" orientation="left" tick={chartAxisTick} />
        <YAxis yAxisId="count" orientation="right" tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(_value, name, props) => {
            const { month, hours, injuryCount } = props.payload;
            if (name === 'hours') return [`${hours} ore`, dayjs(month).format('MMM YYYY')];
            return [`${injuryCount} infortuni`, dayjs(month).format('MMM YYYY')];
          }}
        />
        <Bar yAxisId="hours" dataKey="hours" fill="var(--c-text-0)" radius={[4, 4, 0, 0]} />
        <Bar yAxisId="count" dataKey="injuryCount" fill="var(--ri-critical)" opacity={0.7} radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
